import { z } from '@faceup/validation'
import { DisclosureSubmissionStatus } from '../enums'

/**
 * What changed a submission's status: the auto-approval rules on their own, or the rules applied
 * again after they changed. A member's change joins this list with its actor (ENG-2612).
 */
export const disclosureSubmissionStatusChangeCauses = [
  'AutoApproval',
  'AutoApprovalRulesChange',
] as const

export type DisclosureSubmissionStatusChangeCause =
  (typeof disclosureSubmissionStatusChangeCauses)[number]

// The address an invitation or reminder went to is not repeated here — it belongs to the invite
// the entry hangs off, and duplicating it would let the two drift apart
export const disclosureSubmissionAuditLogPayloadSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('InvitationSent') }),
  z.object({ type: z.literal('ReminderSent') }),
  z.object({
    type: z.literal('StatusChanged'),
    from: z.enum(DisclosureSubmissionStatus),
    to: z.enum(DisclosureSubmissionStatus),
    cause: z.enum(disclosureSubmissionStatusChangeCauses),
  }),
])

export type DisclosureSubmissionAuditLogPayload = z.infer<
  typeof disclosureSubmissionAuditLogPayloadSchema
>

export const disclosureSubmissionAuditLogTypeEnum = z.enum(
  disclosureSubmissionAuditLogPayloadSchema.options.map(option => option.shape.type.value)
).enum
